import React from "react";
import { Avatar, Chip, Icon, Typography } from "@material-ui/core";

const CustomChip = props => (
  <div
    style={{
      width: props.width ? props.width : "100%",
      textAlign: "center",
      ...props.style
    }}
  >
    <Chip
      avatar={
        <Avatar
          style={
            props.avatarStyle
              ? { ...props.avatarStyle }
              : {
                  backgroundColor: "#6c5cab",
                  color: "white"
                }
          }
        >
          <Icon>{props.icon}</Icon>
        </Avatar>
      }
      className="customChip"
      variant="outlined"
      label={
        <Typography
          style={
            props.textStyle
              ? { ...props.textStyle }
              : {
                  color: "white"
                }
          }
        >
          {props.text}
        </Typography>
      }
      color="secondary"
      style={
        props.chipStyle
          ? { ...props.chipStyle }
          : {
              backgroundColor: "#4239d659",
              color: "white"
            }
      }
      onClick={props.clicked}
    />
  </div>
);

export default CustomChip;



// WEBPACK FOOTER //
// ./src/components/CustomChip/CustomChip.jsx